module.exports = __webpack_public_path__ + "img/Background-Toolbox.4437aa3d.jpg";